import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-failed-transaction-dialog',
    templateUrl: './failed-transaction-dialog.component.html',
    styleUrls: ['./failed-transaction-dialog.component.scss'],
    imports: []
})
export class FailedTransactionDialogComponent {
  data: any;

  constructor(public activeModal: NgbActiveModal) {}
}
